import React, { useState } from "react";
import { func } from "prop-types";
import "./index.scss";

const CountryMissingBanner = ({ onOpenModal }) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="country-floating-pill" role="alert" aria-live="polite">
      <div className="pill-content">
        <div className="pill-icon-wrap">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="2" y="5" width="20" height="14" rx="2" />
            <line x1="2" y1="10" x2="22" y2="10" />
          </svg>
        </div>
        <div className="pill-text">
          <span className="pill-label">Wallet Inactive:</span>
          <span className="pill-subtext">Set country to activate payouts & rewards</span>
        </div>
      </div>

      <div className="pill-actions">
        <button
          type="button"
          className="pill-cta-btn"
          onClick={onOpenModal}
        >
          Select Country
        </button>
        <button
          type="button"
          className="pill-close-btn"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          title="Dismiss for this session"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  );
};

CountryMissingBanner.propTypes = {
  onOpenModal: func.isRequired,
};

export default CountryMissingBanner;
